import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import featureFlags from '@dms/feature-flags';
import {testDriveRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {TestDriveCalendar} from './pages/TestDriveCalendar/TestDriveCalendar';

export const TestDriveModule: Module = {
  id: moduleKeys.testDrive,
  layoutProps: {
    title: 'module.testDrive.title',
    icon: 'maps/directions_car',
  },
  routerProps: {
    path: testDriveRoutes.overviewCalendar,
    element: <TestDriveCalendar />,
  },
  requiredPermission: [permissions.readTestDrive],
  requiredFeatureFlag: featureFlags.SALES_TEST_DRIVE_CALENDAR,
  content: [
    {
      id: 'test-drive-overview-calendar',
      routerProps: {
        path: testDriveRoutes.overviewCalendar,
        element: <TestDriveCalendar />,
      },
      layoutProps: {
        title: 'entity.testDrive.labels.calendar',
        icon: 'maps/directions_car',
      },
    },
  ],
};
